"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.modalEventEmitter = void 0;
var tslib_1 = require("tslib");
var eventemitter3_1 = tslib_1.__importDefault(require("eventemitter3"));
var ModalEmitter = /** @class */ (function (_super) {
    tslib_1.__extends(ModalEmitter, _super);
    function ModalEmitter() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return ModalEmitter;
}(eventemitter3_1.default));
exports.modalEventEmitter = new ModalEmitter();
//# sourceMappingURL=event.js.map